import { render, staticRenderFns } from "./profiledocumentform.vue?vue&type=template&id=c8e50c4a&scoped=true&"
import script from "./profiledocumentform.vue?vue&type=script&lang=js&"
export * from "./profiledocumentform.vue?vue&type=script&lang=js&"
import style0 from "./profiledocumentform.vue?vue&type=style&index=0&id=c8e50c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e50c4a",
  null
  
)

export default component.exports